import { render, staticRenderFns } from "./tableTil.vue?vue&type=template&id=67b32c95&scoped=true&"
import script from "./tableTil.vue?vue&type=script&lang=js&"
export * from "./tableTil.vue?vue&type=script&lang=js&"
import style0 from "./tableTil.vue?vue&type=style&index=0&id=67b32c95&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b32c95",
  null
  
)

export default component.exports